"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementCounter = exports.addTimer = exports.getDeviceName = exports.grafanaBasePrefix = void 0;
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_frame_1 = require("@snapchat/web-frame");
const web_sentry_1 = require("@snapchat/web-sentry");
const web_env_1 = require("@snapchat/web-env");
exports.grafanaBasePrefix = "LiveLens";
// TODO: Move to a common grafana package.
function getDeviceName(isMobile) {
    if (typeof isMobile !== "undefined") {
        return isMobile ? "Mobile" : "Desktop";
    }
    return ((0, web_env_1.getWindow)()?.screen.width || 0) < web_frame_1.DESKTOP_MIN_WIDTH ? "Mobile" : "Desktop";
}
exports.getDeviceName = getDeviceName;
function addTimer({ metricsPrefix, pageName, millis, name, }) {
    if (!graphene_1.default.isReady()) {
        (0, web_sentry_1.logSentryError)("Live Lens - Graphene not initialized");
        return;
    }
    const metricsName = `${metricsPrefix}.byPage.${pageName}.byTimer.${name}`;
    graphene_1.default.addTimer({ metricsName, milliSec: millis });
}
exports.addTimer = addTimer;
function incrementCounter(metricsName, value = 1, dimensions) {
    const counterName = `${exports.grafanaBasePrefix}.${metricsName}`;
    graphene_1.default.increment({ metricsName: counterName, dimensions, value });
}
exports.incrementCounter = incrementCounter;
//# sourceMappingURL=grafana.js.map